import { render } from "./TheLocationCreation.vue?vue&type=template&id=56ed7ce8"
import script from "./TheLocationCreation.vue?vue&type=script&lang=js"
export * from "./TheLocationCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__